<template>
  <div class="text-component" :style="getTextStyle">
    <!--    <div class="tinymce" :id="uid" v-html="content" @dblclick="tinymceInit" @blur="getContent"></div>-->
    <!--编辑页的笔记编辑器内容用默认数据替代，预览页显示真实内容-->
    <div v-if="contentType === 2" class="tinymce" :id="uid" v-html="content" ref="textInner" @click.self></div>
    <div v-else-if="contentType === 1" class="bg1">
      <span class="title">预览页将在此处显示每条数据的文章详情</span>
    </div>
    <div v-else-if="contentType === 3">
      <div class="multieditor tl" :id="'noteEditorContent' + myid.container_id + myid.rect_id"></div>
      <!--<div class="multieditor" id="editor1"></div>-->
    </div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import { findCurrentComponentPathInLayoutByRectId } from "utils/index"
import { historyIgnoreWrap } from "utils/revork"

export default {
  mixins: [eventMixin, subPageEventMixin],
  name: "cxNoteEditor",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean
    }
  },
  data() {
    return {
      reloadTimer: null,
      isEditStatu: false,
      activeIds: undefined,
      uid: null,
      clickNum: 0,
      contentType: 3, //1：默认不展示，2：使用以前的插件（错误多，被弃用）3：使用超星笔记编辑器
      MultiEditorParam: {
        largePreview: true,
        isGetVideoDataFromCenter: true
      },
      isFlag: false
    }
  },
  created() {
    if (this.contentType === 3) {
      MultiEditor.init("detail") //加载配置文件，编辑页传参 edit，详情页传参 detail
    }
  },
  watch: {
    "options.detailFieldMapping": {
      deep: true,
      handler(newVal) {
        if (newVal && this.noCacheComponent) {
          historyIgnoreWrap(() => {
            this.updateContent(newVal)
          })()
        }
        if (newVal && this.pageType === "listPage" && !this.isFlag) {
          this.watchClassifyData()
        }
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    zoom() {
      return this.$store.state[this.request_prefix]?.page?.zoom
    },
    content: {
      get() {
        let content = this.options.content
        let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' }
        content = content.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
          return arrEntities[t]
        })
        return content
      },
      set(newVal) {
        let val = newVal.replace(/[<>&" ]/g, function (c) {
          return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&qquot;", " ": "&nbsp;" }[c]
        })
        this.$changeOptionsEV(val, "content", false, undefined, this.myid)
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      if (!this.options.background || !Array.isArray(this.options.background)) {
        return {}
      }
      this.options.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.textPaddingTypeFlag || this.options.textPaddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getTextStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        ...this.bgStyle,
        transform: "rotate(" + this.options.rotate + "deg)",
        height: "100%", //编辑页样式处理
        top: this.options.top,
        left: this.options.left,
        "z-index": this.options.zIndex,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": borderW,
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle
      }
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    }
  },
  mounted() {
    if (this.pageType === "listPage" && this.options?.detailFieldMapping?.isChecked) {
      // 监听列表页分类数据改变
      this.watchClassifyData()
    }
  },
  methods: {
    // 列表页匹配分类数据
    watchClassifyData() {
      this.isFlag = true
      this.$eventBus.$on("classifyDetailDataUpdate", (data)=> {
        this.initListPageIntroductionData(this.options?.detailFieldMapping, true)
      })
    },
    /**
     * 通过列表页插件初始化多级筛选数据
     * @param {*} introduction 详情数据
     */
    initListPageIntroductionData(introduction, isShow) {
      const layout = this.$store.state[this.request_prefix].page.pageLayoutList
      const pageLayoutId = findCurrentComponentPathInLayoutByRectId(layout, this.myid.rect_id).join("_")
      this.$changeOptionsEV(
        isShow,
        "isShow",
        false,
        null,
        {
          pageLayoutId: pageLayoutId
        },
        true
      )
      historyIgnoreWrap(() => {
        this.updateContent(introduction)
      })()
    },
    /**
     * 通过列表页插件初始化多级筛选数据
     * @param {*} plugin 插件实例
     */
    initSubPageIntroductionData(plugin) {
      this.$changeOptionsEV(plugin.showIntroduction, "display", false, null, this.myid, true)
      historyIgnoreWrap(() => {
        this.updateContent(plugin.introduction)
      })()
    },
    updateContent(introduction) {
      // 没有进行字段匹配时，默认展示数据详情内容
      let fieldFlag = this.options.detailFieldMapping?.fieldFlag || "content"
      let detailData = ""
      if (this.pageType === "detailPage" && window.localStorage.getItem("detailData")) {
        detailData = JSON.parse(window.localStorage.getItem("detailData"))[0]
      }
      const appId = this.$store.state?.states?.getDataPageIds?.appId
      if (fieldFlag && this.pageType === "listPage" && window.localStorage.getItem("classifyDetailData-" + appId)) {
        detailData = JSON.parse(window.localStorage.getItem("classifyDetailData-" + appId))[0]
      }
      let dataType = this.options.detailFieldMapping?.dataType || "dataValue"
      if (detailData) {
        // const detailData = JSON.parse(window.localStorage.getItem("detailData"))[0]
        if (fieldFlag && detailData[fieldFlag] && fieldFlag !== "content") {
          if (dataType === "dataKey") {
            introduction = detailData[fieldFlag].key + ":" + detailData[fieldFlag].value
          } else {
            introduction = detailData[fieldFlag].value
          }
        } else {
          introduction = detailData[fieldFlag]
        }
      }
      // 避免出现undefined
      introduction = introduction || ""
      this.content = introduction
      this.$changeOptionsEV(introduction, "content", false, null, this.myid, true)
      if (this.contentType === 3) {
        let _this = this
        let idStr = "noteEditorContent" + _this.myid.container_id + _this.myid.rect_id
        MultiEditor.renderRichtext(idStr, introduction, null, this.MultiEditorParam)
        this.$eventBus.$emit("update-subPage-anchor-data")
      }
    }
  }
}
</script>

<style scoped>
.overflowHidMultiLines {
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-component,
.text-component > div {
  transition: transform 0.5s;
  word-break: break-word;
}
.text-component > div {
  height: 100%;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 8px;
}
/* //滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #eaecf1;
  border-radius: 3px;
}
.content:focus {
  outline: none;
}
.edit-content {
  width: 100%;
  height: 100%;
}
.edit-content textarea {
  width: 100%;
  height: 100%;
  resize: none;
}
.c-pointer:hover {
  cursor: pointer;
}

.text-component ::v-deep .el-scrollbar__view {
  margin-bottom: 0;
}
::v-deep strong {
  font-weight: bold;
  font-style: unset;
}
::v-deep i,
::v-deep em {
  font-style: italic;
}
.tinymce:focus {
  outline: none;
}
.bg1 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 100%;
  height: 100%;
  background: #f7f8fb;
}
.bg1 .title {
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.04em;
  color: #b0b5c1;
}
</style>
